// The Tenor Splitter helper function returns a formatted array eg [1, 'D'].
// This function returns the number unit value.
export function GetTenorUnitFromArray(
  tenorArr: [number, string] | null
): number | null {
  if (tenorArr) {
    return tenorArr[0];
  }
  return null;
}
